import apiClient from "./client";

export const subscribeEmail = async ({ email }) => {
  const response = await apiClient.post("/subscribe", { email });
  return response.data;
};
